interface coord {
  lat: number
  lng: number
}

export default (geo1: coord, geo2: coord) => {
  const R = 6371e3
  const p1 = geo1.lat * Math.PI / 180
  const p2 = geo2.lat * Math.PI / 180
  const deltaP = p2 - p1
  const deltaLon = geo2.lng - geo1.lng
  const deltaLambda = (deltaLon * Math.PI) / 180
  const a = Math.sin(deltaP / 2) * Math.sin(deltaP / 2)
    + Math.cos(p1) * Math.cos(p2)
    * Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2)
  const d = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)) * R
  return d
}
